import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// NOTE: These props are automatically passed to children
const FocusArrow = (
  props, // eslint-disable-line no-unused-vars
) => (
  <svg viewBox="0 0 20 20" className="focusArrow">
    <path d="M0 0 L10 10 L0 20" />
  </svg>
);

// NOTE: These props are automatically passed to children
const InputLine = (
  props, // eslint-disable-line no-unused-vars
) => (
  <svg className="inputLine" viewBox="0 0 40 2" preserveAspectRatio="none">
    <path d="M0 1 L40 1" />
    <path d="M0 1 L40 1" className="activeFocus" />
  </svg>
);

const textBasedInput = ['text', 'email', 'search', 'tel', 'number', 'password', 'url'];
const labelSupported = ['checkbox'];

// NOTE: Label uses appropriate nesting but eslint cannot tell from the children prop
const Label = ({ htmlFor, labelText, order = 'regular', userSelect = true, children }) => (
  <label htmlFor={htmlFor} style={!userSelect ? { userSelect: 'none' } : {}}>
    {' '}
    {/* eslint-disable-line jsx-a11y/label-has-for */}
    {order === 'reverse' && labelText}
    {children}
    {order === 'regular' && labelText}
  </label>
);

const InputField = ({
  defaultVal = '',
  change,
  icon = null,
  fieldType,
  fieldName,
  fieldPlaceholder: fieldPlaceholderProp = null,
  fieldLabel = null,
  focus = false,
  userSelect = true,
  // title = '',
  required = false,
  checked = false,
  line = false,
}) => {

  // if (required) {
  const fieldPlaceholder = `${fieldPlaceholderProp} *`;

  return (
    <p>
      {labelSupported.includes(fieldType) && fieldLabel && (
        <Label htmlFor={fieldName} labelText={fieldLabel} userSelect={userSelect}>
          <input
            defaultValue={defaultVal}
            onChange={change}
            type={fieldType}
            name={fieldName}
            id={fieldName}
            placeholder={textBasedInput.includes(fieldType) ? fieldPlaceholder : null}
            required={required}
            autoFocus={!!focus} // eslint-disable-line jsx-a11y/no-autofocus
            defaultChecked={checked}
          />
        </Label>
      )}
      {textBasedInput.includes(fieldType) && (
        <input
          defaultValue={defaultVal}
          onChange={change}
          type={fieldType}
          name={fieldName}
          placeholder={textBasedInput.includes(fieldType) ? fieldPlaceholder : null}
          required={required}
          autoFocus={!!focus} // eslint-disable-line jsx-a11y/no-autofocus
        />
      )}
      <FocusArrow />
      {icon && <FontAwesomeIcon icon={['fas', icon]} />}
      {line && <InputLine />}
    </p>
  );
};

export default InputField;

InputField.propTypes = {
  defaultVal: PropTypes.string,
  change: PropTypes.func.isRequired,
  icon: PropTypes.string,
  fieldType: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  fieldPlaceholder: PropTypes.string,
  fieldLabel: PropTypes.string,
  focus: PropTypes.bool,
  userSelect: PropTypes.bool,
  // title: PropTypes.string,
  required: PropTypes.bool,
  checked: PropTypes.bool,
  line: PropTypes.bool,
};

Label.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  htmlFor: PropTypes.string.isRequired,
  order: PropTypes.string,
  labelText: PropTypes.string.isRequired,
  userSelect: PropTypes.bool,
};
